<div class="header">
  <div class="title">Review Extracted Fields</div>
  <ts-button
    class="close-button"
    type="icon"
    htmlButtonType="button"
    icon="ts_close"
    (buttonClick)="discard()"
    [tabIndex]="-1"
  ></ts-button>
</div>

<form>
  <ng-container *ngFor="let fieldDef of currentFields; let fieldIndex = index; let isLastField = last">
    <div class="flex flex-row">
      <div class="container__field-list__item__center w-full">
        <app-form-field
          [fieldDef]="fieldDef"
          [model]="model"
          [data]="data"
          [readonly]="false"
          [alwaysHideHistory]="true"
          (onUpdate)="onFieldUpdate($event)"
        ></app-form-field>
      </div>
      <div class="container__field-list__item__right flex">
        <ts-button
          type="icon"
          class="remove-email-field mt-6"
          htmlButtonType="button"
          (buttonClick)="removeField(fieldIndex)"
          buttonTooltip="Remove"
          svgIcon="cancel"
        ></ts-button>
      </div>
    </div>
  </ng-container>
  <!-- Body -->

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <ts-button
        variant="secondary"
        class="discard-button"
        tabIndex="1"
        htmlButtonType="button"
        (buttonClick)="discard()"
      >
        <span>Cancel</span>
      </ts-button>

      <!-- Send -->
      <ts-button variant="primary" class="send-button" htmlButtonType="submit" tabIndex="0" (buttonClick)="save()">
        Save
      </ts-button>
    </div>
  </div>
</form>
